import constants from '@/constants/backend';

export function backendUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (import.meta.env.DEV) return `/api${normalized}`;
  const base = (constants.BACKEND_URL || '').replace(/\/$/, '');
  return `${base}${normalized}`;
}
